import * as React from 'react';

const Block24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 1C5.924 1 1 5.926 1 12c0 6.075 4.924 11 11 11 6.074 0 11-4.925 11-11 0-6.074-4.926-11-11-11M2.5 12a9.5 9.5 0 0 1 15.666-7.227L4.773 18.166A9.46 9.46 0 0 1 2.5 12.002Zm3.334 7.227L19.227 5.834a9.46 9.46 0 0 1 2.273 6.167c0 5.246-4.254 9.499-9.5 9.499a9.46 9.46 0 0 1-6.166-2.273"
  }
));
Block24.Size = 24;
Block24.Title = "Block";

export { Block24 as default };
